import React, { useState } from 'react';

const PhoneSearch = ({ onSearch }) => {
  const [imei, setImei] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (imei.length !== 15) {
      setError('El IMEI debe tener exactamente 15 dígitos');
      return;
    }
    setError('');
    onSearch(imei); // Llama a la función de App.js que consulta al backend
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Introduce el IMEI</h2>
      <div className="flex flex-col">
        <div className="flex">
          <input
            type="text"
            value={imei}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 15);
              setImei(value);
              if (value.length > 0 && value.length !== 15) {
                setError('El IMEI debe tener exactamente 15 dígitos');
              } else {
                setError('');
              }
            }}
            placeholder="Ingrese IMEI (15 dígitos)"
            className="flex-1 border border-gray-300 rounded-l-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]"
            required
          />
          <button
            type="submit"
            disabled={imei.length !== 15}
            className={`bg-[#31a749] text-white py-2 px-4 rounded-r-md hover:bg-[#31a749] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#31a749] ${
              imei.length !== 15 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Consultar
          </button>
        </div>
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    </form>
  );
};

export default PhoneSearch;
